@if (tabs()?.length) {
  <nav
    class="mb-2 flex w-min flex-nowrap items-center gap-3 border-b-2 border-french-blue-500"
    [class]="classOverrides()"
    [class.mb-0!]="isInsightsTabs()"
    [class.gap-0!]="isInsightsTabs()"
  >
    @for (tab of tabs(); track tab) {
      <button
        class="ag1-tab"
        [class]="{
          'rounded-t-md': isInsightsTabs(),
          'border-x': isInsightsTabs(),
          'border-t': isInsightsTabs(),
          'border-french-blue-100': isInsightsTabs(),
          'px-[6px]': isInsightsTabs(),
          'py-[2px]': isInsightsTabs(),
          'text-sm': isInsightsTabs(),
          'ag1-tab--active': tab?.toLowerCase() === activeTab()?.toLowerCase(),
          'bg-french-blue-50':
            tab?.toLowerCase() === activeTab()?.toLowerCase() &&
            isInsightsTabs(),
        }"
        (click)="onTabChanges(tab)"
        [disabled]="loading() || disabledTabs()?.includes(tab)"
      >
        {{ tab | sentenceCase }}
      </button>
    }
  </nav>
}
